import { useState, type FormEvent } from "react";
import { testimonials } from "@/mocks/opinion";

const VALUES = [
  { icon: "ri-check-double-line", title: "客观还原", text: "同时保留代表性声音，不刻意站队，也刻意不做价值审判。" },
  { icon: "ri-file-search-line", title: "可溯源", text: "观点整理基于已公开的公共讨论，欢迎读者指正与补充。" },
  { icon: "ri-refresh-line", title: "随事态更新", text: "风向是流动的，我们会持续跟随讨论进展修正归纳结论。" },
];

function AvatarBubble({ text }: { text: string }) {
  return (
    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 font-heading text-base font-bold text-secondary-900">
      {text.slice(0, 1)}
    </span>
  );
}

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10">
          {/* about text */}
          <div>
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-500"></span> About
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-950">关于九一吃瓜</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              九一吃瓜诞生于一个朴素的观察：当热点发生时，最热闹的地方往往是评论区——那里藏着真实的情绪、清醒的判断，
              也偶尔会有被情绪淹没的误解。我们想做那个替你把评论区看明白的人。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              我们的编辑部每天从公开的网络讨论中，筛选有代表性的网友热评，把分散的、碎片化的观点，
              整理成可读的“风向盘点”。我们关注的是<strong className="text-foreground-950">大家怎么看</strong>，而不是教你怎么想。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              不求速度最快，但求立场客观、梳理清晰、可溯源。每一期内容都是编辑手动甄别、去重、归类后的结果，
              希望它真能帮你少一点被带节奏，多一点独立思考。
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {VALUES.map((v) => (
                <li key={v.title} className="rounded-xl border border-background-200 bg-background-100/60 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${v.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <p className="mt-2.5 font-semibold text-foreground-950">{v.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-700">{v.text}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* testimonials */}
          <div className="flex flex-col justify-center">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">读者怎么说</h3>
            <p className="mt-1 text-sm text-foreground-700">来自订阅者与读者的真实反馈。</p>
            <div className="mt-5 space-y-4">
              {testimonials.map((t) => (
                <figure key={t.nickname} className="rounded-xl border border-background-200 bg-background-100/60 p-4 md:p-5">
                  <div className="flex items-center gap-3">
                    <AvatarBubble text={t.nickname} />
                    <figcaption>
                      <p className="text-sm font-semibold text-foreground-950">{t.nickname}</p>
                      <p className="text-xs text-foreground-600">{t.role}</p>
                    </figcaption>
                    <div className="ml-auto flex items-center gap-0.5 text-secondary-500" aria-label="五星好评">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                      ))}
                    </div>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">“{t.text}”</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}